$(document).ready(function(){
  showCartQuantity();
});

$(window).resize(function() {
  showCartQuantity();
});

function showCartQuantity(){
  $('.showCartItemQuantity').hide();
  var checkIsMobile = isMobile();
  if(checkIsMobile) {
    $('.showCartItemQuantity').show();
  }
}

function isMobile() {
    if (sessionStorage.desktop) // desktop storage 
        return false;
    else if (localStorage.mobile) // mobile storage
        return true;
    var mobile = ['iphone','android','blackberry','nokia','opera mini','windows mobile','windows phone','iemobile']; 
    for (var i in mobile) if (navigator.userAgent.toLowerCase().indexOf(mobile[i].toLowerCase()) > 0) return true;
    return false;
}